
import TableList from "@components/templates/tablelist";
import { HttpExtraServiceList, HttpExportService } from "@/service/costbilling";
import { mapGetters } from "vuex";
import mixin from './mixin'
import comExcel from '@components/templates/excelalert';
export default {
    mixins: [TableList, mixin],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            formData: {

            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpExtraServiceList,
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/billingCostTransactionDetail/export", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'post'
                        }
                    ).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList','getAdminTransferWarehouse', 'getBillcusWareList', 'getCusproductList']),
        ToolsData() {
            return [
                {
                    label: "导出",
                    operate: "export",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "组织",
                    tag: 'vSelect',
                    key: 'EQ_orgId',
                    options: this.getBillcusorgList,
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "仓库",
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getAdminTransferWarehouse,
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "账单",
                    tag: 'vInput',
                    key: 'EQ_billNo',
                    show: true,
                },
                {
                    label: "业务类型",
                    tag: 'vSelect',
                    key: 'EQ_businessType',
                    options: this.getBusinessType,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "事务项",
                    tag: 'vInput',
                    key: 'EQ_transactionCode',
                },

                {
                    label: "计费单号",
                    tag: 'vInput',
                    key: 'EQ_orderNo',
                },
                {
                    label: "识别号",
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                },
                {
                    label: "SKU",
                    tag: 'vInput',
                    key: 'EQ_sku',
                },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
                // {
                //     label: "状态",
                //     key: 'EQ_billId',
                //     more: true,
                //     tag: 'vSelect',
                //     options: this.getBillingDetailStatus,
                //     props: {
                //         filterable: true,
                //     },
                // },
                {
                    label: "备注/Invoice no",
                    tag: 'vInput',
                    key: 'EQ_invoice ',
                },
                {
                    label: "备注/Tracking no",
                    tag: 'vInput',
                    key: 'EQ_tracking',
                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    style: "width:362px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                }
            ]
        },
        columns() {
            return [{
                title: '组织/仓库',
                render: (h, { row }) => {
                    let orgId = row.orgId
                    const { label } = this.getBillcusorgList.find(function (item) {
                        return item.value == orgId
                    }) || {};
                    return <div>
                        <div>{label || '--'}</div>
                        <div>{row.orgWarehouseCode || '--'}</div>
                    </div>
                }
            },
            {
                title: '账单',
                key: 'billNo',
                render: (h, { row }) => {
                    return <div>
                        账单 : {row.billNo}
                        <div>状态:{row.billId == 0 ? '未出账' : '已出账'}</div>
                    </div>
                }
            },
            {
                title: '业务类型/事务项',
                key: 'businessType',
                render: (h, { row }) => {
                    let businessType = row.businessType
                    const { label } = this.getBusinessType.find(function (item) {
                        return item.value == businessType
                    }) || {};
                    return <div>
                        <div>{label || '--'}</div>
                        <div>{row.transactionName || '--'}</div>
                    </div>
                }
            },
            {
                title: '成本',
                key: 'cost',
                render(h, { row }) {
                    return row.billingSourcesType == 'FIXED' ? '' : row.cost
                }
            },
            {
                title: '费率*数量',
                key: 'baseRate',
                render: (h, { row }) => {
                    return <div>{row.baseRate} * {row.qty}</div>
                }
            },
            {
                title: '总费用',
                key: 'totalCost',
                render(h, { row }) {
                    return `${row.totalCost} ${row.currency || 'USD'}`
                }
            },
            {
                title: '计费单号/识别号/SKU/项目',
                width: 180,
                key: 'orderNo',
                render: (h, { row }) => {
                    let lineId = row.lineId
                    const { label } = this.getCusproductList.find(function (item) {
                        return item.value == lineId
                    }) || {};
                    return <div>
                        <div>{row.orderNo || '--'}</div>
                        <div>{row.sourceNo || '--'}</div>
                        <div>{row.sku || '--'}</div>
                        <div>{label || '--'}</div>
                    </div>
                }
            },
            {
                title: '备注 Invoice/备注 Tracking no',
                width: 190,
                render: (h, { row }) => {
                    return <div>
                        {row.invoiceRemark || '--'}
                        <div>{row.trackingRemark || '--'}</div>
                    </div>
                }
            },
            {
                title: '创建日期',
                key: 'createdAt',
                sortable: true
            }
            ];
        },

    },

};
